import React, { useState, useEffect } from "react";

import "./IdCardBack.css";

const IdCardBack = ({ user, addressList }) => {

  const [officeDetails, setOfficeDetails] = useState({
    address: [],
    phone: "",
    office_shift_no: ""
  });

  const handleAddress = () => {
    return officeDetails.address.map((address, index) => <span key={index}>{address}<br /></span>);
  }

  useEffect(() => {
    let officeInfos = addressList.filter(office => {
      return office.name === user.homeOfficeLocation;
    });

    if (officeInfos.length > 0) {
      let officeInfo = officeInfos[0];
      setOfficeDetails({
        address: officeInfo.address,
        phone: officeInfo.phone,
        office_shift_no: officeInfo.office_shift_no
      })
    }
  }, [user.homeOfficeLocation])

  return (
    <div className="id-card-back">
      <div className="id-card-back__top">
        <p className="bold">Property of:</p>
        <p>Thoughtworks Technologies <br />(India) Private Limited</p>
      </div>
      <div className="id-card-back__main">
        <p className="address">{handleAddress()}</p>
        <p>
          {
            officeDetails.phone
              ? <span>Phone: {officeDetails.phone} <br /></span>
              : <span></span>
          }
          {
            officeDetails.office_shift_no
              ? <span>
                {
                  officeDetails.office_shift_no.includes("Office shift no: ")
                  ? ""
                  : "Office shift no: "
                }
                {officeDetails.office_shift_no}
                </span>
              : <span></span>
          }
        </p>
      </div>
      <div className="id-card-back__bottom">
        <p className="bold">If found please return to the <br />above address</p>
        <p className="bold">If lost inform Facilities team <br />immediately</p>
      </div>
    </div>
  )
}

export default IdCardBack;
